export default "__VITE_ASSET__CQV5yLK___"